module.exports = __webpack_public_path__ + "static/omaha-7e20fdce2519d175caa75fdd789fd076.png";